import { MdConstruction, MdSettings, MdOutlineBarChart } from "react-icons/md";
import { TiGroup } from "react-icons/ti";
import { useNavigate } from "react-router-dom";
import { useLocation } from "react-router-dom";
import './Sidebar.css';

const Sidebar = ({ isOpen, setIsOpen, management, collapsed }) => {
    const navigate = useNavigate();
    const location = useLocation();

    const isActive = (path) => location.pathname.startsWith(path);

    const go = (path) => {
        navigate(path);
        setIsOpen(false); // close on mobile
    };

  return (
    <div className={`app-sidebar ${isOpen ? "app-sidebar--open" : ""} ${collapsed ? "app-sidebar--collapsed" : ""}`}>
        <div className="app-sidebar-content">
            
            <div className="app-sidebar-section">
            <h6 className="app-sidebar-title">Main</h6>

            <div title={collapsed ? "Projects" : null} onClick={() => go('/project')} className={`app-sidebar-item ${isActive('/project') ? 'active' : ''}`}>
                <MdConstruction /> <span className={collapsed ? "hidden" : ""}>Projects</span>
            </div>

            <div title={collapsed ? "Companies" : null} onClick={() => go('/companies')} className={`app-sidebar-item ${isActive('/companies') ? 'active' : ''}`}>
                <TiGroup /> <span className={collapsed ? "" : ""}>Companies</span>
            </div>
            </div>

            {management && (
            <div className="app-sidebar-section">
                <h6 className="app-sidebar-title">Insights</h6>

                <div title={collapsed ? "Analytics" : null} onClick={() => go('/analytics')} className={`app-sidebar-item ${isActive('/analytics') ? 'active' : ''}`}>
                <MdOutlineBarChart/> <span className={collapsed ? "hidden" : ""}>Analytics</span>
                </div>
            </div>
            )}

            {management && (
            <div className="app-sidebar-section">
                <h6 className="app-sidebar-title">Admin</h6>

                <div title={collapsed ? "Maintenance" : null} onClick={() => go('/maintenance')} className={`app-sidebar-item ${isActive('/maintenance') ? 'active' : ''}`}>
                <MdSettings /> <span className={collapsed ? "hidden" : ""}>Maintenance</span>
                </div>
            </div>
            )}

        </div>
    </div>
  );
};

export default Sidebar;